<sd-searchbox
  [type]="type"
  [query]="query$ | async"
  [placeholder]="placeholder"
  [isEmpty]="isEmpty$ | async"
  [results]="results$ | async"
  [isLoading]="isLoading$ | async"
  [searchInputControl]="searchInputControl"
  [maxLength]="config.searchPhraseMaxLength"
  (isExpandedChange)="isExpandedChange.emit($event)"
  (clear)="clear()"
  (onClickStsItem)="onClickStsItem($event)"
  (onClickTapItem)="onClickTapItem($event)"
  (onFocusSearchInput)="onFocusSearchInput()"
  (onEnterSearchInput)="onEnterSearchInput()"
  (onClickBrandItem)="onClickBrandItem($event)"
  (isOpenedChange)="onSearchBoxOpened($event)"
  (onClickHistoryItem)="onClickHistoryItem($event)"
  (onClickCategoryItem)="onClickCategoryItem($event)"
  (searchHistoryReset)="searchHistoryService.reset()"
  (searchHistoryRemove)="searchHistoryService.remove($event)"
  (click)="onSearchBoxClick($event)"
>
  <ng-content></ng-content>
</sd-searchbox>
